import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'

@Pipe({ name: 'data' })
export class DataPipe implements PipeTransform {
  
  transform(date: string ): string {
    
    // let dataFormatada= moment(date).format("DD-MM-YYYY HH:mm:ss.SSS");   // Padrão portugues       
    let dataFormatada= moment(date).format("YYYY-MM-D HH:mm:ss");          

    return dataFormatada;
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/data.pipe.ts